import { createAsyncActions } from "@ctra/utils";
import { normalize } from "normalizr";

import schemas from "./schemas";
import types from "./types";
import { FavouritesPayload, FavouritesResponse } from "./typings";

/**
 * Fetch favourites
 */
const fetchFavourites = createAsyncActions(
  types.FETCH_FAVOURITES,
  () => ({}),
  (favouritesResponse: FavouritesResponse) => normalize(favouritesResponse.pages, schemas.favouritesList),
  (error: string) => ({ error })
);

const addToFavourites = createAsyncActions(
  types.ADD_TO_FAVOURITES,
  (favourites: FavouritesPayload, chart, farmID) => ({ favourites, chart, farmID }),
  (_favourites, chart, farmID) => ({ chart, farmID }),
  (error) => ({ error })
);

const removeFromFavourites = createAsyncActions(
  types.REMOVE_FROM_FAVOURITES,
  (favourites: FavouritesPayload, chart, farmID) => ({ favourites, chart, farmID }),
  (_favourites, chart, farmID) => ({ chart, farmID }),
  (error) => ({ error })
);

export default {
  fetchFavourites,
  addToFavourites,
  removeFromFavourites
};
